import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import {Chip, IconButton, Tooltip, Typography, useMediaQuery, useTheme} from "@mui/material";
import React, {useEffect, useState} from "react";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import certifications from "./certifications.json";
import { CloseOutlined } from "@mui/icons-material";

const CreatorCertifications = ({certificateId}) =>{
    const [certificate, setCertificate] = useState(null);
    const [initialized, setInitialized] = useState(false);
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));
    useEffect(() => {
        if(!initialized){
            setInitialized(false);
            const cert = certifications[certificateId];
            if(cert){
                setCertificate(cert);
            }
        }
    }, [initialized, certificateId, certifications]);
    const onClose = () => {
        setOpen(false);
    }
    const onOpen = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setOpen(true);
    }
    if(certificate){
        return <ClickAwayListener onClickAway={onClose}>
            <div>
            <Tooltip
            open={open}
            onClose={onClose}
            onOpen={onOpen}
            PopperProps={{
                disablePortal: true,
                sx:{
                    "& .MuiTooltip-tooltip":{
                        backgroundColor: '#ffffff',
                        filter: 'drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.25))',
                        padding: "16px"
                    },
                    "& .MuiTooltip-arrow":{
                        color: '#ffffff'
                    }
                }
            }}
            disableTouchListener
            title={<>
            <Typography component={'span'} variant={'caption'} fontSize={'14px'}>{certificate.description}</Typography>
                {isMobileView && <IconButton onClick={onClose} sx={{position: 'absolute', top: 0, right: 0}}>
                    <CloseOutlined />
                </IconButton>}
        </>} placement={'top'} arrow sx={{fontSize: '14px'}}>
            <Chip onTouchEnd={onOpen} sx={{backgroundColor: '#ebebeb', fontSize: '14px', lineHeight: '21px', px: '12px', margin: '3px', cursor: 'pointer'}} label={certificate.title} icon={<GppGoodOutlinedIcon sx={{height: "16px", width: "16px"}} color={'#323232'} />} />
        </Tooltip>
            </div>
        </ClickAwayListener>
    }
    else{
        return <></>
    }
}
export default CreatorCertifications;